/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Why_Weights_DescInputs */

const en_landing_why_weights_desc = /** @type {(inputs: Landing_Why_Weights_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideogram says open weights are coming; none were published at launch.`)
};

const zh_landing_why_weights_desc = /** @type {(inputs: Landing_Why_Weights_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideogram 表示开放权重即将推出，发布时尚未公开。`)
};

/**
* | output |
* | --- |
* | "Ideogram says open weights are coming; none were published at launch." |
*
* @param {Landing_Why_Weights_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_why_weights_desc = /** @type {((inputs?: Landing_Why_Weights_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Why_Weights_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_why_weights_desc(inputs)
	return zh_landing_why_weights_desc(inputs)
});
export { landing_why_weights_desc as "landing.why.weights_desc" }